import { Component, OnInit, Inject } from "@angular/core";
import { CommonService } from "../../../common/common.service";
import { Router, ActivatedRoute } from "@angular/router";
import { APPCONSTANT } from "../../../common/common.const";
import swal from "sweetalert2";
import { SessionStorageService, LocalStorageService } from "ngx-webstorage";
import { ToastConfig, ToastrService, ToastrModule } from "ngx-toastr";
import { environment } from "../../../../environments/environment";
import { LoginService } from "../login.service";
import { HttpClientService } from "../../../common/http-client.service";
import { ToastService } from "../../../common/toast.service";
import { Headers, RequestOptions } from "@angular/http";

@Component({
  selector: "app-activation-link",
  templateUrl: "./activation-link.component.html",
  styleUrls: ["./activation-link.component.css"],
  providers: [LoginService],
})
export class ActivationLinkComponent implements OnInit {
  reset: any = {
    userName: null,
    newPassword: "",
    confirmPassword: "",
    otpflag: "true",
  };
  passwordShow: object = {};
  cpasswordShow: object = {};
  id: string = "";
  role: string = "";
  adminDetails: any = null;
  passwordSetup: boolean = false;
  passwordSetSuccess: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private commonService: CommonService,
    private http: HttpClientService,
    private toast: ToastService
  ) {
    //this.route.params.subscribe( params => console.log(params) );
    console.log("in activate component");
  }
  showPopup: boolean = false;

  ngOnInit() {
    this.showPopup = true;
    this.route.queryParams.subscribe((params) => {
      this.id = params["linkId"]; // This is the linkId from URL query parameter
      if (this.id) {
        this.fetchAdminDetails();
      } else {
        this.toast.error("Invalid activation link. Link ID is missing.");
      }
    });
  }

  fetchAdminDetails() {
    this.loading = true;
    // Step 3: Call user-management API with linkId
    const url = `userManagement/admin/LINK_ID/${this.id}?isPayload=0`;

    // Follow the exact same auth header pattern as login
    // Create header object with same headers as login request
    let head: any = {};
    head[this.commonService.authToken] = this.commonService.staticToken;
    // Add userId header if available (same pattern as refresh/logout service)
    const userId = this.commonService.getUserId();
    if (userId) {
      head[this.commonService.headerUserId] = userId;
    }
    // jwt() method automatically adds locale: "en" and language: "ENG"
    // These match the headers sent during login

    // Pass header to http.get() - jwt() method will convert it to RequestOptions
    // This is the same pattern used in login.service.ts
    this.http.get(url, null, 6, head as any).subscribe(
      (response) => {
        this.loading = false;
        console.log("API Response:", response);

        // Handle new API response structure with result and data wrappers
        // Check for statusCode as both number (200) or string ("200")
        let adminData = null;

        // Try to extract data from different possible response structures
        if (response && response.result && response.data) {
          const statusCode = response.result.statusCode;
          if (statusCode === 200 || statusCode === "200") {
            adminData = response.data;
          }
        } else if (response && response.entityId) {
          // Fallback: response might be directly the data object
          adminData = response;
        } else if (response && response.data && response.data.entityId) {
          // Another fallback: data might be nested differently
          adminData = response.data;
        }

        if (adminData && adminData.entityId) {
          // Extract admin details
          this.adminDetails = adminData;
          console.log("Admin Details extracted:", this.adminDetails);

          // Map statusName to status for template compatibility
          if (this.adminDetails.statusName) {
            this.adminDetails.status = this.adminDetails.statusName;
          }
          // Extract userName from response data
          if (this.adminDetails.userName) {
            this.adminDetails.username = this.adminDetails.userName;
          }
          this.passwordSetup = true;
          console.log(
            "Password setup enabled, adminDetails:",
            this.adminDetails
          );
        } else {
          console.error(
            "Response structure issue - Could not extract admin data:",
            {
              hasResponse: !!response,
              hasResult: !!(response && response.result),
              statusCode:
                response && response.result ? response.result.statusCode : null,
              hasData: !!(response && response.data),
              hasEntityId: !!(response && response.entityId),
              fullResponse: response,
            }
          );
          const errorMsg =
            (response && response.result && response.result.userMsg) ||
            (response && response.message) ||
            "Admin details not found or invalid link.";
          this.toast.error(errorMsg);
          this.adminDetails = null;
        }
      },
      (error) => {
        this.loading = false;
        console.error("Error fetching admin details:", error);
        // Handle error response that might be in error._body or error.error
        let errorMessage = "Failed to fetch admin details. Please try again.";
        if (error && error.error) {
          try {
            const errorBody =
              typeof error.error === "string"
                ? JSON.parse(error.error)
                : error.error;
            if (errorBody && errorBody.result && errorBody.result.userMsg) {
              errorMessage = errorBody.result.userMsg;
            }
          } catch (e) {
            // If parsing fails, use default message
          }
        }
        this.toast.error(errorMessage);
        this.adminDetails = null;
      }
    );
  }
  invalidPassword: boolean = false;
  invalidOld: boolean = false;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  passwordMismatch: boolean = false;
  minLengthError: boolean = false;
  maxLengthError: boolean = false;
  confirmMaxLengthError: boolean = false;
  loading: boolean = false;
  passwordStrength: string = "";
  submitted: boolean = false;
  private passwordPolicyRegex: RegExp =
    /^(?=.*[A-Za-z0-9])(?=.*[@#$%^&+=]).{6,20}$/;

  private calculatePasswordStrength(password: string): string {
    if (!password) {
      return "";
    }

    let score = 0;

    const length = password.length;
    const hasLetter = /[A-Za-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecial = /[@#$%^&+=]/.test(password);

    if (length >= 6) score++;
    if (length >= 10) score++;

    const types = [hasLetter, hasNumber, hasSpecial].filter(Boolean).length;
    if (types >= 2) score++;
    if (types === 3) score++;

    if (score <= 1) {
      return "Weak";
    } else if (score === 2 || score === 3) {
      return "Medium";
    } else {
      return "Strong";
    }
  }

  changePassword(v) {
    // Update validation before checking
    this.validatePassword();
    this.validateConfirmPassword();
    this.submitted = true;

    if (this.invalidPassword || this.invalidOld) return false;
    if (this.reset["newPassword"] !== this.reset["confirmPassword"] || !v) {
      return false;
    }

    if (!this.adminDetails) {
      this.toast.error("Admin details not available.");
      return;
    }

    // Get username from adminDetails (userName from response)
    const userName = this.adminDetails.userName || this.adminDetails.username;
    if (!userName) {
      this.toast.error("Admin username not available.");
      return;
    }

    // Prepare payload matching reset service format
    const data = {
      userName: userName,
      newPassword: this.reset.newPassword,
      oldPassword: this.reset.confirmPassword,
      otpflag: "Y",
    };

    let head: any = {};
    head[this.commonService.authToken] = this.commonService.staticToken;
    const userId = this.commonService.getUserId();
    if (userId) {
      head[this.commonService.headerUserId] = userId;
    }

    this.loading = true;
    this.http
      .post("adminController/changePassword", data, 7, head as any)
      .subscribe(
        (response) => {
          this.loading = false;
          if (response["status"] === "success") {
            this.passwordSetSuccess = true;
            swal({
              title: "Success",
              text: "Password changed successfully",
              type: "success",
              confirmButtonText: "Ok",
            }).then(
              () => {
                // Password set successfully, button is now disabled and login link is shown
              },
              () => {}
            );
          } else {
            // Prefer backend error message (e.g. "Duplicate Password") when available
            const statusCode = response["statusCode"];
            const backendMessage = response && response["message"];

            if (backendMessage) {
              swal("Error!", backendMessage, "info");
            } else if (statusCode === "-20") {
              swal("Error!", "Unable to update password", "info");
            } else {
              swal("Error!", "Unable to update password", "info");
            }
          }
        },
        (error) => {
          this.loading = false;
          console.error("Error setting password:", error);
          // Try to surface backend message from error response if present
          try {
            const errBody = (error && error._body) ? JSON.parse(error._body) : null;
            const backendMessage =
              errBody && (errBody.message || errBody.errorDescription);
            if (backendMessage) {
              swal("Error!", backendMessage, "info");
            } else {
              swal(
                "Error!",
                "Oops ! Something went wrong. Please try again after 5 minutes.",
                "info"
              );
            }
          } catch (e) {
            swal(
              "Error!",
              "Oops ! Something went wrong. Please try again after 5 minutes.",
              "info"
            );
          }
        }
      );
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  validatePassword() {
    this.minLengthError = false;
    this.maxLengthError = false;
    this.invalidPassword = false;

    if (this.reset.newPassword && this.reset.newPassword.length > 0) {
      if (this.reset.newPassword.length < 6) {
        this.minLengthError = true;
      }

      if (this.reset.newPassword.length > 20) {
        this.maxLengthError = true;
      }

      if (
        this.reset.newPassword.length >= 6 &&
        this.reset.newPassword.length <= 20
      ) {
        this.invalidPassword = !this.passwordPolicyRegex.test(
          this.reset.newPassword.trim()
        );
      }
    }

    // Calculate password strength
    this.passwordStrength = this.calculatePasswordStrength(
      this.reset.newPassword
    );

    // Always check for mismatch when new password changes
    this.checkPasswordMatch();
  }

  validateConfirmPassword() {
    this.confirmMaxLengthError = false;
    this.invalidOld = false;

    if (this.reset.confirmPassword && this.reset.confirmPassword.length > 0) {
      if (this.reset.confirmPassword.length > 20) {
        this.confirmMaxLengthError = true;
      }

      if (
        this.reset.confirmPassword.length >= 6 &&
        this.reset.confirmPassword.length <= 20
      ) {
        this.invalidOld = !this.passwordPolicyRegex.test(
          this.reset.confirmPassword.trim()
        );
      }
    }

    // Always check for mismatch when confirm password changes
    this.checkPasswordMatch();
  }

  checkPasswordMatch() {
    // Show mismatch error if EITHER field has content and they don't match
    if (this.reset.newPassword || this.reset.confirmPassword) {
      if (this.reset.newPassword && this.reset.confirmPassword) {
        // Both fields have content - check if they match
        this.passwordMismatch =
          this.reset.newPassword !== this.reset.confirmPassword;
      } else if (
        this.reset.confirmPassword &&
        this.reset.confirmPassword.length >= 6
      ) {
        // Only confirm password has content (6+ chars) - show mismatch
        this.passwordMismatch = true;
      } else {
        this.passwordMismatch = false;
      }
    } else {
      this.passwordMismatch = false;
    }
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/auth/login/activation-link/activation-link.component.ts